<script lang="ts" setup>
  import { GDialog } from '@flash-global66/g-dialog';
  import { GButton } from '@flash-global66/g-button';
  import { useSessionExpirationAlert } from './useSessionExpirationAlert';
  
  interface Props {
    show: boolean;
    timeRemaining: number;
  }
  
  interface Emits {
    (e: 'extend-session'): void;
    (e: 'close-session'): void;
  }
  
  const props = defineProps<Props>();
  const emit = defineEmits<Emits>();
  
  const {
    countdownMinutes,
    countdownSeconds, 
    handleExtendSession, 
    handleCloseSession,
  } =  useSessionExpirationAlert(props, emit);
</script>

<template>
  <GDialog
    :model-value="show"
    title="Tu sesión está por expirar"
    :show-close="false"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <section class="text-secondary-txt text-center">
      <p>
        Tu sesión finalizará en
        <strong class="text-primary-txt">{{ countdownMinutes }}:{{ countdownSeconds }}</strong
        >. Para continuar, extiende tu sesión. También puedes cerrar sesión ahora.
      </p>
    </section>

    <template #footer>
      <div class="grid gap-5 pt-6 mt-auto">
        <GButton full data-test="button:Extender sesión" @click="handleExtendSession">
          Mantener sesión activa
        </GButton>
        <GButton
          full
          variant="secondary"
          data-test="button:Cerrar sesión"
          @click="handleCloseSession"
        >
          Cerrar sesión
        </GButton>
      </div>
    </template>
  </GDialog>
</template>
